// Desc: initial state for pcb fabrication including data when return from cart
import _ from 'lodash'

import defaultState from './defaultState';
import { PRICE_SELECTED, QUOTED } from '../../../shared/pu-data/QuoteSteps';

const state = _.cloneDeep(defaultState);

if (Spree.fabrication) {
  const { quote, quote_parameters } = Spree.fabrication
  state.quantitiesChanged = true
  state.lineItemId = Spree.fabrication.line_item_id;
  state.quote = quote;
  state.parameters = Object.assign({}, state.parameters, quote_parameters);

  if (quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
} else if(Spree.assembly) {
  const { part_number, revision, filename } = Spree.assembly.quote_parameters;

  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.stencils && Spree.stencils.length > 0) {
  // if the project dont include fabrication, but include stencils take parameters from stencils
  const { parameters: stencilParameters } = Spree.stencils[0];
  let { part_number: partNumber } = stencilParameters;
  if (partNumber.endsWith('-Top Side')) {
    partNumber = partNumber.replace('-Top Side', '');
  } else if (partNumber.endsWith('-Bottom Side')) {
    partNumber = partNumber.replace('-Bottom Side', '');
  } else if (partNumber.endsWith('-Combine Top & Bottom')) {
    partNumber = partNumber.replace('-Combine Top & Bottom', '');
  }
  state.parameters.part_number = partNumber;
  state.parameters.revision = stencilParameters.revision;
  state.parameters.filename = stencilParameters.filename;
} else if (Spree.parts) {
  // if the project dont include fabrication, but include parts take parameters from parts
  state.parameters.part_number = Spree.parts.part_number;
  state.parameters.revision = Spree.parts.revision;
  state.parameters.filename = Spree.parts.zip_file;
}

export default state;
